/** Format first + last name for display */
export function fullName(
  person: { first_name?: string | null; last_name?: string | null } | null | undefined
): string {
  if (!person) return '';
  return `${person.first_name || ''} ${person.last_name || ''}`.trim();
}
